// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"40a84189","339":"358ab86b","501":"4681e57e","631":"0a5c89e6","920":"40d6a93f"}[chunkId] + ".chunk.js";
};